// Database işlemeleri yapılacak ve dönen datanın state e geçmesi için mutation a gönderilecek
import sendReq from '@/utils/request'

export const adattribute_list = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("get","system/ad-operations")
    commit('ADAttributes', res.data);
   commit('LDAPLoading', false);
}

export const adfilter_add = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("post","system/ad-filters", data)
    commit('LDAPStatus', res.data);
   commit('LDAPLoading', false);
}

export const adfilter_edit = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("put","system/ad-filters/"+data.id, data)
    commit('LDAPStatus', res.data);
   commit('LDAPLoading', false);
}

export const adfilter_detail = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("get","system/ad-filters/"+data.id)
    commit('LDAPFilterDetail', res.data);
   commit('LDAPLoading', false);
}

export const adfilter_delete = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("delete","system/ad-filters/"+data.id,)
    commit('LDAPStatus', res.data);
   commit('LDAPLoading', false);
}

export const adfilter_list = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("get","system/ad-filters")
    commit('ADFilters', res.data);
   commit('LDAPLoading', false);
}

export const adfilter_run = async ({ commit }, data) => {
   commit('LDAPLoading', true);
   let res;
   res = await sendReq("post","system/ad-filters/"+data.id+'/run')
   commit('setLDAPData', res.data);
  commit('LDAPLoading', false);
}

export const ADUser_list = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("post","system/ad-filters/"+data[0]+'/run')
    commit('setLDAPData', res.data);
   commit('LDAPLoading', false);
}

export const ldapuser_add = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("post","system/ldap/users", data)
    commit('LDAPStatus', res.data);
   commit('LDAPLoading', false);
}

export const adfields_get = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("get","/system/alr-ad-match")
    commit('ADFields', res.data);
   commit('LDAPLoading', false);
}

export const adfields_edit = async ({ commit }, data) => {
   commit('LDAPLoading', true);
    let res;
    res = await sendReq("put","/system/alr-ad-match", data)
    commit('LDAPStatus', res.data);
   commit('LDAPLoading', false);
}



// WEBPACK FOOTER //
// ./src/store/modules/LDAP/Actions.js